<template>
  <form @submit.prevent="onSubmit">
    <p class="pr-4">
      {{ city.paymentScreen }}
    </p>
    <b-row align-v="end">
      <b-col>
        <label for="discount-input">
          {{ $t('dp.buttons.promoCode') }}
          <b-button id="discount-info" class="tooltip-btn" title="fees info">
            <fa-icon size="sm" :icon="['fas', 'info-circle']" />
          </b-button>
          <b-tooltip target="discount-info" triggers="hover click blur" placement="right">
            {{ $t('components.discount.notApplyTip') }}
          </b-tooltip>
        </label>
        <form-input v-if="order.discount" id="discount-input" :placeholder="order.discount.code" disabled />
        <form-input
          v-else
          id="discount-input"
          v-model="input"
          placeholder="Enter Code"
          :readonly="loading || hasAutomatedDiscounts"
          :aria-disabled="loading || hasAutomatedDiscounts ? 'true' : null"
          :aria-describedby="hasAutomatedDiscounts ? 'discount-blocked-reason' : null"
        />
      </b-col>
      <b-col cols="4">
        <b-button
          type="submit"
          variant="primary"
          block
          :disabled="loading || (!input && !order.discount)"
          :aria-disabled="hasAutomatedDiscounts ? 'true' : null"
          :aria-describedby="hasAutomatedDiscounts ? 'discount-blocked-reason' : null"
        >
          {{ order.discount ? 'Remove' : 'Apply' }}
          <div v-if="loading" role="status" class="fa-pulse float-right mt-1">
            <fa-icon :icon="['fas', 'spinner']" class="d-flex" />
            <span class="sr-only">{{ $t('dp.buttons.loading') }}</span>
          </div>
        </b-button>
      </b-col>
    </b-row>
    <p v-if="hasAutomatedDiscounts" id="discount-blocked-reason" class="small text-muted mt-1 mb-0">
      {{ $t('components.discount.automatedDiscountBlocksPromo') }}
    </p>
    <h4 v-if="success && promoCodeExcludesSaleItems && hasOnSaleItems" class="text-danger mt-2 mb-0">
      {{ $t('components.discount.excludesSaleItems') }}
    </h4>
    <h4 v-else-if="success" class="text-success mt-2 mb-0">{{ success }}</h4>
    <h4 v-else-if="error" class="text-danger mt-2 mb-0">{{ error }}</h4>
  </form>
</template>

<script>
import { mapState } from 'vuex';
import formInput from '@/components/FormInput.vue';
import { CookieMixins } from '@/mixins/cookie';

export default {
  components: {
    formInput,
  },
  mixins: [CookieMixins],
  data() {
    return {
      input: '',
    };
  },
  computed: {
    ...mapState({
      orderId: state => state.orderId,
      order: state => state.order.order,
      cityId: state => state.cityId,
      city: state => state.order.order.city,
      success: state => state.order.discount.success,
      error: state => state.order.discount.error,
      loading: state => state.order.discount.loading,
    }),
    promoCodeExcludesSaleItems() {
      return this.order?.discount?.code && !this.order.discount.includeSaleItems;
    },
    hasOnSaleItems() {
      return this.order?.items?.some((item) => Number(item.product?.discountedPrice) > 0 && item.product?.type === 'DESIGNER_TAG');
    },
    hasAutomatedDiscounts() {
      return this.order?.items?.some(item => item.automatedDiscountState === 'APPLIED');
    },
  },
  methods: {
    onSubmit() {
      if (this.hasAutomatedDiscounts) {
        return;
      }

      if (this.order.id) {
        if (this.order.discount) {
          this.$store.dispatch('order/removeDiscount');
          this.input = null;
        } else {
          this.$store.dispatch('order/applyDiscount', { orderId: this.orderId, code: this.input });
        }
      } else {
        const data = this.splitSetBasket();
        const discountCode = this.getBasketCodeCookie();
        if (discountCode) {
          this.$store
            .dispatch('order/createLocalOrder', { vm: this, cityId: this.cityId, data, discountCode: null, changingDiscount: true })
            .then(() => this.removeBasketCodeCookie());
        } else {
          this.$store
            .dispatch('order/createLocalOrder', {
              vm: this,
              cityId: this.cityId,
              data,
              discountCode: this.input,
              changingDiscount: true,
            })
            .then(() => {
              this.setBasketCodeCookie(this.input);
              this.input = null;
            });
        }
      }
    },
  },
};
</script>

<style></style>
